module.exports = __webpack_public_path__ + "93a3f95f0037d8eabe06510b2601e562.svg";